<template>
  <div v-if="label">
    <template v-if="userInfos">
    <h2 class="subtitle">{{label.titles.title}}  <Info multilined bottom :tooltipText="label.titles.titleTooltip"/></h2>
    <div>
      <h3 class="subtitle">{{label.titles.generalInfo}}</h3>
      <form @submit.prevent="submitModifForm">
        <!-- <div>
          {{label.forms.lastName}} :
          <template v-if="editingInfos">
            <input v-model="infosForm.lastName" type="text" maxlength="50">
          </template>
          <template v-else><label>{{userInfos.lastName}}</label></template>
        </div>
        <div>
          {{label.forms.firstName}} :
          <template v-if="editingInfos">
            <input v-model="infosForm.firstName" type="text" maxlength="50">
          </template>
          <template v-else>{{userInfos.firstName}}</template>
        </div> -->
        <div>
          {{label.forms.Email}} :
          {{userInfos.email}}
        </div>
        <!-- <div>
          {{label.forms.phone}} :
          <template v-if="editingInfos">
            <input v-model="infosForm.phoneNumber" type="text" maxlength="35">
          </template>
          <template v-else>{{userInfos.phoneNumber ? userInfos.phoneNumber : '--'}}</template>
        </div> -->
        <!-- <div>
          {{label.forms.channel}} :
          <template v-if="editingInfos">
            <select v-model="infosForm.preferredChannel">
              <option value="email">email</option>
              <option value="sms">SMS</option>
            </select>
            <div id="note">{{label.forms.channelInfo}}</div>
          </template>
          <template v-else>{{infosForm.preferredChannel}}</template>
        </div> -->

        <!-- boutons d'actions pour modifier save cancel -->
        <!-- <div class="confirm" v-if="editingInfos">
          <button class="button is-primary" type="submit">{{label.buttons.save}}</button>
          <button class="button is-white" type="button" @click="cancelInfoEdition">{{label.buttons.cancel}}</button>
        </div> -->
      </form>
      <!-- <a class="info-modify button is-outlined is-info" v-if="!editingInfos" @click="editingInfos = !editingInfos">{{label.buttons.modify}}</a> -->
    </div>

    <h3 class="subtitle big-margin-top">{{label.titles.parameters}}</h3>
    <!-- accessibilité malvoyant -->
    <div class="vertical-align">
      <span>Activer l'accessibilité pour les daltoniens  <Info multilined :tooltipText="label.forms.accessibilityTooltip"/> : </span><input v-model="infosForm.accessibilityEnabled" @change="changeAccessibility(infosForm.accessibilityEnabled)" type="checkbox" class="switch">
    </div>

    <!-- choix de notifications -->
    <!-- <h3 class="subtitle big-margin-top">{{label.titles.notification}}</h3> -->
    <!-- notifications facultatives -->
    <!-- <div class="field">
      <div v-for="optionalNotification of optionalNotifications" :key="optionalNotification.id">
        <input
          v-model="allowedNotifications"
          :value="optionalNotification.id"
          :id="optionalNotification.id"
          type="checkbox"
          @change="updateBlockedNotifications">
        <label :for="optionalNotification.id">{{label.forms.optionalNotificationList[optionalNotification.NAME]}}  <Info multilined :tooltipText="label.forms.adminNotifTooltip"/></label>
      </div>
    </div> -->
    <!-- notifications obligatoires -->
    <!-- <div class="field">
      <strong>{{label.forms.mandatoryNotification}}</strong>
      <div v-for="mandatoryNotification of mandatoryNotifications" :key="mandatoryNotification.id">
        <input
          disabled
          checked
          type="checkbox">
        <label>{{mandatoryNotification.NAME}}</label>
      </div>
    </div> -->

    <h3 class="subtitle big-margin-top">{{label.titles.actions}}</h3>

    <button
      :disabled="loadingFullUserInfos"
      @click="loadFullUserInfos"
      v-if="!fullUserInfos && !loadingFullUserInfos"
      class="button is-outlined is-primary has-tooltip-top has-tooltip-multiline"
      style="max-width: 100%; white-space: normal; height: auto;"
      :data-tooltip="label.buttons.askDownloadTooltip">
      {{label.buttons.askDownload}}
    </button>

    <div v-if="fullUserInfos || loadingFullUserInfos">
      <template v-if="fullUserInfos">
        <button
          class="button is-outlined is-primary has-tooltip-top has-tooltip-multiline"
          style="max-width: 100%; white-space: normal; height: auto;"
          :data-tooltip="label.buttons.downloadDataTooltip"
          @click.prevent="downloadData([fullUserInfos], 'user-informations.json')"
        >{{label.buttons.downloadData}}</button>
      </template>
      <template v-else>
        <!-- Loading -->
        <strong>{{label.texts.dataPreparation}}...</strong>
      </template>
    </div>

    <div>
      <a class="info-delete button is-outlined is-danger"
        style="max-width: 100%; white-space: normal; height: auto;"
        @click="setShowDeleteAccountModal(true)">{{label.buttons.delete}}</a>
      <p v-if="showDeleteMessage">{{deleteMessage}}</p>
    </div>

    <div v-if="showDeleteAccountModal" class="modal" :class="{ 'is-active': showDeleteAccountModal }">
      <div class="modal-background" @click="setShowDeleteAccountModal(false)"></div>
        <div class="modal-content">
            <div class="box">
                <div class="title">
                  {{label.buttons.delete}}
                </div>
                <!-- email -->
                <div class="field">
                  <label class="label" for="confirm-delete-input">{{label.texts.emailToDelete}} : {{ userInfos.email }}</label>
                  <div class="control">
                    <input id="confirm-delete-input" maxlength="500" class="input input-large" type="text" v-model="confirmDeleteEmailInput">
                  </div>
                </div>
                <!-- bouton suppression définitive -->
                <p class="big-margin-top has-tooltip-top has-tooltip-multiline">
                  <button :disabled="!confirmDeleteEmailInputIsCorrect" @click="deleteUserConfirm" class="button is-danger"
                    :data-tooltip="label.buttons.deleteAccountTooltip"
                  >{{label.texts.definitivelyDelete}}</button>
                  <button @click="setShowDeleteAccountModal(false)" class="button is-info right"
                    data-tooltip="Annuler"
                  >Annuler</button>
                </p>
            </div>
        </div>
    </div>
    
    <div v-if="showDeleteSuccessModal" class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box has-text-centered">
          <p class="title is-5">{{label.texts.deleteDataSuccess}}</p>
        </div>
      </div>
    </div>
    </template>
    <template v-else>{{label.texts.loading}}...</template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { UserService } from '../services'

import Info from '../components/Info.vue'

export default {
  components: {
    Info
  },
  data() {
    return {
      editingInfos: false,
      infosForm: null,
      userInfos: null,

      // download all my data
      fullUserInfos: null,
      loadingFullUserInfos: false,

      channels: ['email', 'sms'],

      showDeleteMessage: false,
      deleteMessage: "",

      // notification choice
      allowedNotifications: [],
      optionalNotifications: [],
      mandatoryNotifications: [],

      // deletion safety confirmation
      showDeleteAccountModal: false,
      showDeleteSuccessModal: false,
      confirmDeleteEmailInput: undefined,
    }
  },
  computed: {
    ...mapState("account", ["user"]),
    ...mapState({ label: state => state.labels.infos }),
    confirmDeleteEmailInputIsCorrect() {
      return this.confirmDeleteEmailInput && (this.confirmDeleteEmailInput == this.userInfos.email)
    }
  },
  methods: {
    ...mapActions("account", ["deleteUser", "changeAccessibility", "logoutAfterDeletion"]),
    ...mapActions("labels", ["getLabel"]),
    updateBlockedNotifications() {
      UserService.updateBlockedNotifications({
        clientID: this.user._id,
        idListBlockedNotifs: this.optionalNotifications.filter(notif => !this.allowedNotifications.includes(notif.id)).map(notif => notif.id)
      }).then(() => {
      })
    },
    setShowDeleteAccountModal(value) {
      this.showDeleteAccountModal = value
      if(!value)
        this.confirmDeleteEmailInput = undefined
    },
    loadFullUserInfos() {
      this.loadingFullUserInfos = true
      UserService.loadFullUserInfos(this.user._id).then(fullUserInfos => {
        this.fullUserInfos = fullUserInfos
        this.loadingFullUserInfos = false
      }, () => this.loadingFullUserInfos = false)
    },
    downloadData(data, label) {
      var jsonData = JSON.stringify(data, null, 2);
      var blobData = new Blob([jsonData], {type: "application/json"});
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blobData);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    handleSuccess() {
    },
    handleError() {
    },
    loadClientInfos() {
      UserService.getClientById(this.user._id).then(userInfos => {
        this.onLoadedClientInfos(userInfos)
      })
    },
    loadNecessaryInfos() {
      let promises = []
      // promise to load general user infos
      promises.push(UserService.getClientById(this.user._id))
      // promise to load all types of notifications
      promises.push(UserService.loadAllTypesOfNotifications())

      Promise.all(promises).then(data => {
        this.onLoadedClientInfos(data[0])
        this.onLoadedAllTypesOfNotifs(data[1])
      })
    },
    onLoadedClientInfos(userInfos) {
      this.editingInfos = false
      this.infosForm = {...userInfos}
      this.userInfos = userInfos
    },
    onLoadedAllTypesOfNotifs(allNotifs) {
      this.optionalNotifications = allNotifs.OPTIONAL
      this.mandatoryNotifications = allNotifs.MANDATORY
      this.allowedNotifications = this.optionalNotifications.filter(notif => {
          return !this.userInfos?.blockedNotifications?.some(blockedNotifID => {
            return blockedNotifID == notif.id
          })
        }
      ).map(notif => notif.id)
    },
    cancelInfoEdition() {
      this.editingInfos = false;
      this.infosForm = {...this.userInfos};
    },
    submitModifForm() {
      this.editingInfos = false;
      UserService.modifyUserInfos(this.infosForm).then(() => {
        this.infosForm = {...this.userInfos};
        this.loadClientInfos()
      });
    },
    deleteUserConfirm() {
      this.deleteMessage = this.label.texts.deleteData
      this.showDeleteMessage = true
      this.setShowDeleteAccountModal(false)

      this.deleteUser(this.user._id)
        .then(() => {
          this.showDeleteMessage = false
          this.showDeleteSuccessModal = true
          setTimeout(() => {
            this.logoutAfterDeletion()
          }, 3000)
        })
        .catch(() => {
          this.deleteMessage = "Une erreur est survenue, si le problème persiste, veuillez contacter votre gestionnaire de réseau"
        })
    },
  },
  created() {
    this.getLabel({ view: 'infos' })
    this.loadNecessaryInfos()
  }
}
</script>

<style scoped>
.big-margin-top {
  margin-top: 1.5rem;
}

.small-margin-top {
  margin-top: 12px;
}

.input-large {
  width: 300px !important;
}

.margin-top {
  margin-top:14px;
}

#note {
  font-size: 11px;
}

.confirm,
.info-modify,
.info-delete {
  margin-top: 1rem;
}

.vertical-align {
  display: flex;
  align-items: center;
  gap: 10px;
}

.right {
  float: right
}
</style>